<template>
  <b-modal
    id="medpadala-modal"
    body-class="modal-body"
    title="MEDPadala"
    centered
    header-class="align-items-center"
    title-class="text-center flex-grow-1"
    hide-footer
    @hidden="resetMedPadala"
  >
    <template v-slot:modal-header-close>
      <img
        src="@/assets/images/ic-circle-close.svg"
        class="close-btn"
        data-dismiss="modal"
        @click="$root.$emit('bv::hide::modal', 'medpadala-modal')"
      />
    </template>
    <div
      id="medpadala-logo-container"
      class="text-center py-4"
      v-if="medPadalaCustomization"
    >
      <img
        :src="medPadalaCustomization.logo"
        alt="MEDPadala"
        class="medpadala-logo"
      />
    </div>
    <b-form @submit.prevent>
      <b-row>
        <b-col cols="9" class="mx-auto">
          <CodeAndPin v-if="medPadalaStep === 1" />
          <Balance v-if="medPadalaStep === 2" />
          <UseMedPadalaCredits v-if="medPadalaStep === 3" />
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import CodeAndPin from "./CodeAndPin";
import UseMedPadalaCredits from "./UseMedPadalaCredits";
import Balance from "./Balance";

export default {
  name: "MEDPadalaModal",
  components: {
    CodeAndPin,
    Balance,
    UseMedPadalaCredits
  },
  computed: {
    ...mapFields("medpadala", ["code", "pin", "errors", "medPadalaStep"]),
    ...mapGetters({
      medPadalaCustomization: "medpadala/medPadalaCustomization"
    })
  },
  methods: {
    resetMedPadala() {
      if (this.medPadalaStep < 3) {
        this.code = null;
        this.pin = null;
      }
      this.medPadalaStep = 1;
      this.errors = null;
    }
  }
};
</script>

<style lang="scss">
#medpadala-modal {
  .close {
    padding: 0 5px 0 0;
    outline: 0;
    box-shadow: none;
  }
  h5 {
    font-size: 20px;
  }
  .modal-body {
    background: #fefeff;
  }
  .medpadala-logo {
    width: 120px;
    height: auto;
  }
}
</style>
